module.exports = __webpack_public_path__ + "img/mobelnetworktest2.a4601fc.png";